import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableEntryAdmin } from '@reflact/ipkv-types';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-table',
  imports: [
    TableModule,
    CommonModule,
    FormsModule,
    TextareaModule
  ],
  templateUrl: './table.html',
  styleUrl: './table.scss'
})
export class Table implements OnChanges {
  @Input() table: TableEntryAdmin[][] = [];

  testTable: TableEntryAdmin[][] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['table']) {
      this.resetTable();
    }
  }

  resetTable() {
    this.testTable = this.table.map(row =>
      row.map(cell => ({ ...cell, solution: cell.isEditable ? '' : (cell as any).solution ?? '' }))
    );
  }

  getAnswers(): string[][] {
    return this.testTable.map(row =>
      row.map(cell => cell.isEditable ? (cell.solution || '') : '')
    );
  }

  setAnswers(answers: string[][]) {
    for (let r = 0; r < this.testTable.length && r < answers.length; r++) {
      // Full-width rows (as produced by getAnswers) are indexed by column, compact rows by editable cell
      const fullWidth = answers[r].length === this.testTable[r].length;
      let editableIdx = 0;
      for (let c = 0; c < this.testTable[r].length; c++) {
        const cell = this.testTable[r][c];
        if (cell.isEditable) {
          cell.solution = (fullWidth ? answers[r][c] : answers[r][editableIdx]) ?? '';
          editableIdx++;
        }
      }
    }
  }
}
